import { HIDE_HOMEPAGE_LOGO, CDN_URL } from '@lib/constants';

import style from './index.module.scss';

export default function HomepageLogo({
	animationClass = '',
	animationData = {},
}) {
	if (true === HIDE_HOMEPAGE_LOGO) {
		return null;
	}

	return (
		<div
			className={`homeLayout__logo ${style.logo} ${animationClass}`}
			{...animationData}
		>
			<img
				src={CDN_URL + '/logo-homepage.webp'}
				alt="Dark Blue Prospectus Plus logo"
				width={193}
			/>
		</div>
	);
}